import {FC, PropsWithChildren} from "react";

interface Props extends PropsWithChildren {
    condition: boolean;
}

export const ShowWhen: FC<Props> = ({ condition, children }) => {
    if (condition) {
        return <>{children}</>;
    }
    return null;
};